import { PrepareAPIService } from './PrepareAPIService'

export const AppHTTPService = new PrepareAPIService()
export const api = AppHTTPService.client
